export const GET_SITE_DETAIL_AJAX_SUCCESS = "GET_SITE_DETAIL_AJAX_SUCCESS";